/** wrapper around a type to avoid circular dependency issue due to reflect metadata */
export type Reference<T> = T;
